export default __webpack_public_path__ + "static/media/refund.244d194f.jpg";